import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TFTSMonthlyFilterRequest } from '../../types/fts-monthly';
import { FTS_MONTHLY_ACTIONS_NAME } from './name';
import { TFTSMonthlyState } from './types';

import { TPageMetadata } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchTableData(
  context: ActionContext<TFTSMonthlyState, unknown>,
  payload: TBaseFilterPayload<TFTSMonthlyFilterRequest & TPageMetadata>,
) {
  return request(
    context,
    {
      url: links.ved.fts.monthly.getTableData,
      name: getLocalState(FTS_MONTHLY_ACTIONS_NAME.searchTableData),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
